import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=2c71f6d0&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetails.vue?vue&type=style&index=0&id=2c71f6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c71f6d0",
  null
  
)

export default component.exports